import { BoxProps } from '@mui/material';
import { TFunction } from 'i18next';

import { NamespacesList } from 'core/enums/common';

export interface TableHeader {
	label: string | null;
	align: 'right' | 'left' | 'center' | 'inherit' | 'justify' | undefined;
}

export interface StatusBoxType extends BoxProps {
	type: string;
}

export const fileOperationsErrors = (
	translate: TFunction<NamespacesList.common, undefined, NamespacesList.common>
) => ({
	failedOperation: {
		title: translate('errors.fileOperationTitle'),
		description: translate('errors.fileOperationDescription'),
	},
});
